<template lang="pug">
    .tip-button(
        @click="$emit('toggle-show-tip-variable')"
    )
        svg-icon.tip__arrow-icon(
            name="angle-left",
            size="small",
            :class="{'tip__arrow-icon--rotated': arrowIconRotated}"
        )
        img.tip__icon(src="../../../assets/icons/exclamation-mark.svg" :style="{width: isForBonusGames && '25px',height: isForBonusGames && '25px'}")
        .tip__text
            | {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}
</template>

<script>
    export default {
        props: {
            arrowIconRotated: {
                type: Boolean,
                default: false,
            },
            isForBonusGames: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .tip-button {
        cursor: pointer;
        width: 100px;
        height: 43px;
        border-radius: $border-radius-40;
        background: $x-color-white;
        display: flex;
        align-items: center;
        justify-content: center;
        @include media($sm) {
            width: 169px;
            height: 64px;
        }
        @include media($lg) {
            width: 200px;
            height: 76px;
            border-radius: $border-radius-40;
        }
        .tip__arrow-icon {
            color: #2187ff;
            transition: all 0.3s ease;
        }
        .tip__arrow-icon--rotated {
            transform: scaleX(-1);
        }
        .tip__icon {
            margin-left: -5px;
            margin-right: -4px;
            width: 22px;
            height: 22px;

            pointer-events: none;
            @include media($sm) {
                margin-left: 0;
                margin-right: 0;
                width: 26px;
                height: 26px;
            }
            @include media($md) {
                width: 32px;
                height: 32px;
            }
        }
    }
    .tip__text {
        font-size: $font-size-12;
        @include media($sm) {
            font-size: 15px;
        }
        @include media($lg) {
            font-size: $font-size-18;
        }
    }
</style>
